// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"errorform_errorMessage__3wlmU","red":"errorform_red__1mtgd"};